import React, { useState } from 'react';
import styles from './HotkeysLabel.module.css';

const HotkeysLabel: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className={styles.container}>
      <span 
        className={styles.label}
        onMouseEnter={() => setShowPopup(true)}
        onMouseLeave={() => setShowPopup(false)}
      >
        HOTKEYS
      </span>
      {showPopup && (
        <div className={styles.popup}>
          <table className={styles.hotkeyTable}>
            <tbody>
              <tr>
                <td>Space</td>
                <td>Play/Pause</td>
              </tr>
              <tr>
                <td><span className={styles.arrow}>←</span></td>
                <td>5s backwards</td>
              </tr>
              <tr>
                <td><span className={styles.arrow}>→</span></td>
                <td>5s forwards</td>
              </tr>
              <tr>
                <td>Shift <span className={styles.arrow}>←</span></td>
                <td>Previous round</td>
              </tr>
              <tr>
                <td>Shift <span className={styles.arrow}>→</span></td>
                <td>Next round</td>
              </tr>
              <tr>
                <td>M</td>
                <td>Mute/Unmute</td>
              </tr>
              <tr>
                <td>Z</td>
                <td>Minimap zoom</td>
              </tr>
              <tr>
                <td>N</td>
                <td>New note</td>
              </tr>
              <tr>
                <td>Ctrl + Enter</td>
                <td>Save note</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default HotkeysLabel;